import {Params} from '@angular/router';

// import {PropsMapping} from '@shared/interfaces';
import {Model} from './model';

// const propsMapping: PropsMapping = {
const propsMapping: Params = {
  id: 'sportId',
  name: 'name',
};

export class SportModel extends Model {
  name!: string;

  static getInstance(data: Params): SportModel {
    const model = new SportModel();
    for (const prop in propsMapping) {
      if (
        data[propsMapping[prop]] === undefined ||
        data[propsMapping[prop]] === null
      ) {
        continue;
      }

      (model as Params)[prop] = data[propsMapping[prop]];
    }
    return model;
  }
}
